"use client";

import type { UseOpenApiQueryOptions } from "../../../../../request/hooks/openApi/useOpenApiQuery";
import { useOpenApiQuery } from "../../../../../request/hooks/openApi/useOpenApiQuery";
import { keyCommunitiesStripeConnectStatus } from "./keyCommunitiesStripeConnectStatus";

const STRIPE_CONNECT_STATUS_PATH =
  "/me/communities/{community_id}/stripe/status" as const;

export type UseRequestCommunitiesStripeConnectStatusProps = Omit<
  UseOpenApiQueryOptions<typeof STRIPE_CONNECT_STATUS_PATH>,
  "urlBackendPath" | "params"
> & {
  id: number;
};

export const useRequestCommunitiesStripeConnectStatus = ({
  id,
  ...props
}: UseRequestCommunitiesStripeConnectStatusProps) => ({
  query: useOpenApiQuery({
    ...props,
    urlBackendPath: STRIPE_CONNECT_STATUS_PATH,
    params: { path: { community_id: id } },
    queryKey: keyCommunitiesStripeConnectStatus({ id }),
  }),
});
